import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { useObjectOpen } from './useObjectOpen';

/*
  ObjectLink — ссылка на объект внутри рабочего пространства. Настоящая <a href>, поэтому адрес
  можно скопировать, а клавиатура и читалки видят ссылку; но открывает она вкладку, а не
  новую страницу: клик — здесь, Ctrl/⌘ и средняя кнопка — на фоне, Shift — рядом.
*/

interface ObjectLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
}

export const ObjectLink = forwardRef<HTMLAnchorElement, ObjectLinkProps>(
  ({ to, onClick, onAuxClick, children, ...rest }, ref) => {
    const open = useObjectOpen();
    return (
      <a
        ref={ref}
        href={to}
        // Shift+клик открывает рядом — и не должен выделять текст между кликами, как на обычной странице.
        onMouseDown={(e) => {
          if (e.shiftKey) e.preventDefault();
        }}
        onClick={(e) => {
          onClick?.(e);
          if (e.defaultPrevented || e.button !== 0) return;
          e.preventDefault();
          e.stopPropagation();
          open(to, e);
        }}
        onAuxClick={(e) => {
          onAuxClick?.(e);
          if (e.defaultPrevented || e.button !== 1) return;
          e.preventDefault();
          e.stopPropagation();
          open(to, e);
        }}
        {...rest}
      >
        {children}
      </a>
    );
  },
);
ObjectLink.displayName = 'ObjectLink';
